// Generated from evals/results/tenants/eval-cineplexx-hr/manifest.json — do not hand-edit.
//
// A JavaScript shell. Brand extraction drove a real browser and came back at 0.95
// confidence; capability observation, reading the 5.5 kB served HTML, proposed nothing
// at all.
//
//
// Every value below was produced by a real crawl of the live site with LLM
// synthesis disabled (--no-llm). Nothing is invented, including the parts that
// do not flatter the pipeline.

import type { Manifest } from '@clawharbor/manifest';

export const CINEPLEXX_MANIFEST: Manifest = {
  "$schema": "https://clawharbor.io/schema/manifest/v1.json",
  "manifestVersion": "1.0.0",
  "id": "cineplexx-hr",
  "generatedAt": "2026-08-27T22:18:05.296Z",
  "generator": {
    "name": "clawharbor",
    "version": "0.1.0",
    "mode": "assisted"
  },
  "source": {
    "inputUrl": "https://www.cineplexx.hr/",
    "canonicalOrigin": "https://www.cineplexx.hr",
    "redirectChain": [
      "https://www.cineplexx.hr/"
    ],
    "platform": {
      "server": "nginx",
      "rendering": "client"
    },
    "robots": {
      "fetchedAt": "2026-08-27T22:17:59.000Z",
      "disallowAll": false,
      "rules": [],
      "sitemaps": [
        "https://www.cineplexx.hr/sitemap.xml"
      ]
    },
    "crawl": {
      "userAgent": "ClawHarborBot/1.0 (+https://clawharbor.io/bot)",
      "pages": 1,
      "maxRps": 0.5
    }
  },
  "identity": {
    "displayName": "www.cineplexx.hr",
    "locale": "en",
    "altLocales": [],
    "timezone": "UTC",
    "currency": "EUR",
    "contact": {},
    "logo": {
      "url": "https://www.cineplexx.hr/favicon-32.png",
      "kind": "png",
      "source": "manifest:icons",
      "usage": "reference-only"
    },
    "wordmark": {
      "text": "www.cineplexx.hr",
      "case": "asIs"
    }
  },
  "brand": {
    "mode": "dark",
    "palette": {
      "brand.primary": {
        "evidence": [
          "cta-background:button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll",
          "link-color:a.CybotCookiebotDialogDetailBodyContentCookieLink",
          "link-color:a",
          "score=0.35 chroma=0.225 gate=1.00 sources=cta-background+link-color+area-residue+accent-border+text-color+surface-background"
        ],
        "confidence": 0.95,
        "derived": false,
        "value": "#de1619",
        "oklch": "oklch(57.21% 0.2254 27.98)"
      },
      "brand.onPrimary": {
        "evidence": [
          "observed-on-primary:pair:cta button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll | pair:element a.sc-bdVaJa.LRCVX",
          "contrast:4.96:1"
        ],
        "confidence": 0.92,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "brand.primaryHover": {
        "evidence": [
          "derived:lightness +0.06 OKLCH from brand.primary"
        ],
        "confidence": 0.5,
        "derived": true,
        "value": "#f43730",
        "oklch": "oklch(63.22% 0.2249 28)"
      },
      "brand.secondary": {
        "evidence": [
          "surface-background:.rpb-item--active occurrences:1",
          "runner-up-to-primary: score=0.06 chroma=0.207 gate=1.00 sources=surface-background"
        ],
        "confidence": 0.3,
        "derived": false,
        "value": "#4c78ff",
        "oklch": "oklch(61.6% 0.2065 266.63)"
      },
      "bg.canvas": {
        "evidence": [
          "canvas:painted-area area=1633388 paint=1 nodes=body,div.CybotCookiebotDialogActive == body"
        ],
        "confidence": 0.92,
        "derived": false,
        "value": "#191919",
        "oklch": "oklch(21.34% 0 0)"
      },
      "bg.surface": {
        "evidence": [
          "background:div.sc-kIPQKe.footer__main-wrapper area=481050 paint=1",
          "background:div.sc-kpOJdX.b-image-with-loader__inner area=111659 paint=48",
          "surface-weight=0.29 deltaE-from-canvas=0.084 hue-affinity=1.00"
        ],
        "confidence": 0.78,
        "derived": false,
        "value": "#2d2d2d",
        "oklch": "oklch(29.72% 0 0)"
      },
      "bg.raised": {
        "evidence": [
          "background:div area=1296000 paint=141",
          "surface-background:.react-multiple-carousel__arrow occurrences:1",
          "surface-weight=0.10 deltaE-from-canvas=0.213 hue-affinity=1.00"
        ],
        "confidence": 0.85,
        "derived": false,
        "value": "#000000",
        "oklch": "oklch(0% 0 0)"
      },
      "bg.footer": {
        "evidence": [
          "footer-background:div.sc-kIPQKe.footer__main-wrapper",
          "header-background:header.sc-gzOgki.header",
          "footer-background weight=0.80"
        ],
        "confidence": 0.95,
        "derived": false,
        "value": "#2d2d2d",
        "oklch": "oklch(29.72% 0 0)"
      },
      "fg.default": {
        "evidence": [
          "text-color:body occurrences:5",
          "text-color:.rpb-item--active occurrences:5",
          "text-weight=0.82 contrast-on-canvas=17.58:1"
        ],
        "confidence": 0.93,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "fg.muted": {
        "evidence": [
          "text-color:div.sc-bwCtUz.footer__secondary-copyright glyphs=21",
          "text-color:a.l-footer-main__link glyphs=20",
          "text-weight=0.17 contrast-on-canvas=6.80:1"
        ],
        "confidence": 0.77,
        "derived": false,
        "value": "#a1a1a1",
        "oklch": "oklch(70.9% 0 0)"
      },
      "fg.onBrand": {
        "evidence": [
          "observed-on-primary:pair:cta button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll | pair:element a.sc-bdVaJa.LRCVX",
          "contrast:4.96:1",
          "same as brand.onPrimary"
        ],
        "confidence": 0.92,
        "derived": true,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "border.default": {
        "evidence": [
          "border-color:.react-multi-carousel-dot button occurrences:1",
          "border-weight=0.46 contrast=4.45:1 hue-affinity=1.00"
        ],
        "confidence": 0.63,
        "derived": false,
        "value": "#808080",
        "oklch": "oklch(59.99% 0 0)"
      },
      "accent.premium": {
        "evidence": [
          "derived:no premium/gold/vip selector found; reusing brand.secondary"
        ],
        "confidence": 0.2,
        "derived": true,
        "value": "#4c78ff",
        "oklch": "oklch(61.6% 0.2065 266.63)"
      },
      "state.success": {
        "evidence": [
          "derived:no success colour observed; platform default"
        ],
        "confidence": 0.15,
        "derived": true,
        "value": "#16a34a",
        "oklch": "oklch(62.71% 0.1699 149.21)"
      },
      "state.danger": {
        "evidence": [
          "cta-background:button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll",
          "link-color:a.CybotCookiebotDialogDetailBodyContentCookieLink",
          "danger-hint=0.00 hue=28 chroma=0.225"
        ],
        "confidence": 0.85,
        "derived": false,
        "value": "#de1619",
        "oklch": "oklch(57.21% 0.2254 27.98)"
      }
    },
    "typography": {
      "families": {
        "sans": {
          "observed": "sans-serif",
          "licensed": true,
          "licenseNote": "system family: served by the visitor OS, nothing to rehost",
          "substitute": {
            "family": "sans-serif",
            "source": "system",
            "subsets": [
              "latin",
              "latin-ext"
            ],
            "weights": [
              400,
              600,
              700
            ],
            "metricOverrides": null
          },
          "stack": "ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif"
        },
        "display": {
          "observed": "Open Sans",
          "rendered": "Open Sans",
          "licensed": true,
          "licenseNote": "Open Sans is on Google Fonts under the SIL Open Font License; served, not rehosted",
          "substitute": {
            "family": "Open Sans",
            "source": "google",
            "license": "OFL-1.1",
            "subsets": [
              "latin",
              "latin-ext"
            ],
            "weights": [
              700
            ],
            "metricOverrides": null
          },
          "stack": "\"Open Sans\", ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif"
        }
      },
      "baseSizePx": 15,
      "baseWeight": 400,
      "headingWeight": 700,
      "scale": {
        "ratio": 1.2,
        "steps": {
          "sm": 12,
          "md": 15,
          "lg": 18
        }
      },
      "case": {
        "heading": "uppercase",
        "button": "none"
      },
      "tracking": {
        "button": "0.007em",
        "body": "0.007em"
      }
    },
    "shape": {
      "radius": {
        "card": 15,
        "control": 4,
        "chip": 999
      },
      "borderWidth": 1
    },
    "elevation": {
      "sm": "rgba(0, 0, 0, 0.2) 0px 2px 4px 0px",
      "md": "rgba(222, 22, 25, 0.16) 0px 3px 16px 0px",
      "lg": "rgba(0, 0, 0, 0.3) 0px 32px 68px 0px"
    },
    "density": {
      "spaceBase": 8,
      "scale": [
        0,
        4,
        8,
        12,
        16,
        24,
        32,
        48,
        64
      ]
    },
    "motion": {
      "durationMs": 350,
      "easing": "ease-out"
    }
  },
  "domain": {
    "entities": {},
    "vocabularies": {}
  },
  "capabilities": [],
  "views": [],
  "copy": {},
  "policy": {
    "ownership": "third-party",
    "disclaimer": "Unofficial. Not affiliated with, endorsed by, or operated by www.cineplexx.hr. Information is read live from www.cineplexx.hr and every transaction is completed on their own site.",
    "assets": {
      "rehostImages": false,
      "rehostFonts": false,
      "rehostText": false
    },
    "data": {
      "retainHistory": false,
      "maxHorizonDays": 7,
      "maxRps": 0.5
    },
    "deepLinkOnly": true,
    "takedownUrl": "https://clawharbor.io/takedown"
  },
  "contentHash": "sha256:b972181280951044ef9e8cbf94477c2305c15953273c27c73cc429789ddf7e89"
};
